import { render, staticRenderFns } from "./VesselRegister-1.vue?vue&type=template&id=6fb6eab2&scoped=true"
import script from "./VesselRegister-1.vue?vue&type=script&lang=js"
export * from "./VesselRegister-1.vue?vue&type=script&lang=js"
import style0 from "./VesselRegister-1.vue?vue&type=style&index=0&id=6fb6eab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6eab2",
  null
  
)

export default component.exports